<div class="container">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="d-flex popup-head align-items-center">
                <div class="popup-title mr-auto" translate>lblEditBrand</div>
                <div class="float-right">
                  <a class="close mr-3" (click)="OnClose()" translate>
                    <span class="" aria-hidden="true">&times;</span>
                    </a>
                </div>
              </div>
            <div *ngIf="editBrandForm">
                <form [formGroup]="editBrandForm" (ngSubmit)="EditBrand()">
                    <div class="scrollbar">
                        <div class="card-content">
                            <div class="card-body p-0">
                                <div class="form-row">
                                    <div class="col-6 af-form-group">
                                        <label for="service" translate>lblBrandCode
                      <strong class="mlt6 required"> * </strong> </label>
                                        <div class="lbl-info">
                                            <input formControlName="brandCode" class="form-control mb-2" [ngClass]="{'is-invalid': cpf.brandCode.invalid}" maxlength="15" readonly>
                                            <div *ngIf="cpf.brandCode.invalid || (cpf.brandCode.touched && (cpf.brandCode.errors?.required))" class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle" aria-hidden="true"></em> lblBrandCodeRequired
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-6 af-form-group">
                                        <label class="text" for="service" translate>lblBrandName
                      <strong class="mlt6 required"> * </strong> </label>
                                        <div class="lbl-info">
                                            <input formControlName="brandName" class="form-control mb-2" [ngClass]="{'is-invalid': cpf.brandName.invalid}" maxlength="25">
                                            <div *ngIf="cpf.brandName.touched && (cpf.brandName.errors?.required)" class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle" aria-hidden="true"></em> lblBrandNameRequired
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xl-3 af-form-group">
                                        <div class='lbl-info'>
                                          <div>
                                            <label class="btn btn-outline-primary d-inline-block" for="select-files"
                                              translate>lblChangeLogo</label>
                                            <input type="file" id="select-files" ame="image" (change)="onChangeFileUpload($event.target.files)"
                                            accept=".png, .jpg, .jpeg" (change)="onChangeFileUpload($event.target.files)" [ngClass]="{'is-invalid': cpf.image.invalid}" hidden
                                            required>
                                            <p class="text-muted">
                                                <span translate class="fnt10">lblNote</span><span class="fnt10">: </span><span translate class="fnt10">lblFileSizeLessThan100KB</span>
                                            </p>
                                            <div *ngIf="cpf.image.touched && (cpf.image.errors?.required)" class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle" aria-hidden="true"></em> lblImageRequired
                                            </div>
                                          </div>
                                          <img af-image [data-code]="brandModel.image" [data-src]="ImageBinaryData" id="UploadImage" alt="image does not found." class="carimg border mt-2 p-2">
                                        </div>
                                      </div>
                                    <div class="col-12 af-form-group">
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                                            <label class="custom-control-label" for="isActive" translate>lblActive</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-3 bg-light pp-footer-top-brdr">
                    <div class="row">
                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                            <button type="submit" class="btn btn-primary btn-lg mr-sm-2" [disabled]="!editBrandForm.valid || !isValidImg" translate aria-label="Center Align"><em class="far fa-save font16 align-top mr-2"></em> lblSaveChanges</button>
                            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>
                                 lblCancel</a>
                        </div>
                    </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>